<div>Account header {{searchCaseNumber}}
</div>